export default {
  getTimeData: state => {
    return state.timeData;
  },
  getActiveTimeWindow(state) {
    return state.activeTimeWindow;
  },
  getActiveTimeSlice: state => {
    return state.activeTimeSlice;
  },
  getMaxTime: state => {
    return state.maxTime;
  },
  showTimeFilters: state => {
    return state.showTimeFilters;
  },
  showBottomPanel: state => {
    return state.showBottomPanel;
  },
  getActiveDays: state => {
    return state.activeDays;
  },
  getActivePeaks: state => {
    return state.activePeaks;
  },
};
